// Copyright (c) 2022 by Move Closer

/**
 * FIXME: Refactor (Task #34693)
 *
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const filterCurrency = (value: unknown): string => {
  const candidate: number = typeof value !== 'number' ? parseFloat(String(value)) : value
  if (isNaN(candidate)) {
    return 'Invalid value'
  }

  return candidate.toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(',00', '') + ' zł'
}
